import { AppRoute, Route } from './lib/common.types';
import { BillingPageComponent } from './pages/billing-page/billing-page.component';
import { ClaimPageComponent } from './pages/claim-page/claim-page.component';
import { LandingPageComponent } from './pages/landing-page/landing-page.component';
import { ReportPageComponent } from './pages/report-page/report-page.component';
import { DocumentsPageComponent } from './pages/documents/documents-page/documents-page.component';
import { ScheduleAPageComponent } from './pages/scheduleA-page/scheduleA-page.component';
import { EmployeePageComponent } from './pages/employee-page/employee-page.component';
import { AddEmployeeComponent } from './pages/employee-page/add/add.component';
import { CreateClaimComponent } from './pages/claim-page/create/create.component';
import { AllFormsPageComponent } from './pages/form/forms-page.component';
import { ClaimsFormsPageComponent } from './pages/form/claims-page.component';
import { EmployeeFormsPageComponent } from './pages/form/employee-page.component';
import { TaxFormsPageComponent } from './pages/form/tax-page.component';
import { DashboardPageComponent } from './pages/dashboard-page/dashboard-page.component';
import { FinancialTaxPageComponent } from './pages/financial/tax/tax-page.component';

export const benefitsRoutes: AppRoute[] = [
  { path: 'landing', text: 'Landing', component: LandingPageComponent },
  { path: 'dashboard', text: 'Dashboard', component: DashboardPageComponent },
  { path: 'billing', text: 'Billing', component: BillingPageComponent },
  {
    path: 'financial/tax',
    text: 'Tax',
    component: FinancialTaxPageComponent
  },
  {
    path: 'employees',
    text: 'Search Employees',
    component: EmployeePageComponent
  },
  {
    path: 'employees/add',
    text: 'Add Employees',
    component: AddEmployeeComponent
  },
  { path: 'claims/search', text: 'Claims', component: ClaimPageComponent },
  {
    path: 'claims/create',
    text: 'Create Claim',
    component: CreateClaimComponent
  },
  { path: 'report', text: 'EOI Report', component: ReportPageComponent },
  {
    path: 'documents',
    text: 'Contract Documents',
    component: DocumentsPageComponent
  },
  { path: 'letter', text: 'Tax Forms', component: ScheduleAPageComponent },
  {
    path: 'allforms',
    text: 'Forms',
    component: AllFormsPageComponent,
    children: [
      {
        path: '',
        text: 'Forms',
        redirectTo: 'claimsform',
        pathMatch: 'full'
      },
      {
        path: 'claimsform',
        text: 'Claims Forms',
        component: ClaimsFormsPageComponent
      },
      {
        path: 'employeeform',
        text: 'Employee Forms',
        component: EmployeeFormsPageComponent
      },
      {
        path: 'taxform',
        text: 'Tax Forms',
        component: TaxFormsPageComponent
      }
    ]
  }
];

export const landingPageRoutes: Route[] = [
  {
    path: 'policies',
    text: 'All policies'
  }
];
